import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import { Alert, Box, Skeleton, Stack, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { livyJson } from 'src/lib/livyApi';
const rate = v => v === undefined || v === null ? '-' : Number(v).toFixed(1);

/**
 * Support deflection: HubSpot tickets people wrote each week, split by whether the company has Livy on, normalised
 * per 100 companies so the groups compare. Written weekly by the data-pipelines livy-deflection flow; counts only.
 */
export function DeflectionTab() {
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    data = _useState2[0],
    setData = _useState2[1];
  const _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    error = _useState4[0],
    setError = _useState4[1];
  useEffect(() => {
    livyJson('/metrics/deflection').then(setData).catch(e => setError(e.message));
  }, []);
  if (error) return /*#__PURE__*/React.createElement(Alert, {
    severity: "error",
    sx: {
      mt: '16px'
    }
  }, error);
  if (!data) return /*#__PURE__*/React.createElement(Stack, {
    spacing: "8px",
    sx: {
      mt: '16px'
    }
  }, [0, 1, 2].map(i => /*#__PURE__*/React.createElement(Skeleton, {
    key: i,
    height: 40
  })));
  return /*#__PURE__*/React.createElement(Box, {
    sx: {
      pt: '16px'
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "text.secondary",
    sx: {
      mb: '12px',
      maxWidth: 720
    }
  }, "Tickets people wrote to support each week (automated tickets counted apart), joined to Livable companies through HubSpot's Livable pro ID. Per 100 companies, a lower number for Livy-on companies means Livy is answering questions that used to become tickets.", data.kbAnswers.satisfaction !== null && " Answers from help articles: ".concat(data.kbAnswers.satisfaction, "% rated helpful (").concat(data.kbAnswers.rated, " ratings).")), data.weeks.length === 0 ? /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "text.secondary"
  }, "No weeks yet. The livy-deflection flow writes them daily.") : /*#__PURE__*/React.createElement(Box, {
    sx: {
      overflowX: 'auto'
    }
  }, /*#__PURE__*/React.createElement(Table, {
    size: "small",
    "aria-label": "Support tickets by week"
  }, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, ['Week', 'Human tickets', 'Automated', 'Livy on', 'Livy off', 'Unlinked', 'Per 100, Livy on', 'Per 100, Livy off'].map(h => /*#__PURE__*/React.createElement(TableCell, {
    key: h,
    sx: {
      fontWeight: 600,
      whiteSpace: 'nowrap'
    }
  }, h)))), /*#__PURE__*/React.createElement(TableBody, null, data.weeks.map(w => /*#__PURE__*/React.createElement(TableRow, {
    key: w.sk
  }, /*#__PURE__*/React.createElement(TableCell, null, w.sk), /*#__PURE__*/React.createElement(TableCell, null, w.humanTickets), /*#__PURE__*/React.createElement(TableCell, null, w.automatedTickets), /*#__PURE__*/React.createElement(TableCell, null, w.livyOnTickets, " (", w.livyOnCompanies, " cos)"), /*#__PURE__*/React.createElement(TableCell, null, w.livyOffTickets, " (", w.livyOffCompanies, " cos)"), /*#__PURE__*/React.createElement(TableCell, null, w.unmappedTickets), /*#__PURE__*/React.createElement(TableCell, null, rate(w.livyOnPer100)), /*#__PURE__*/React.createElement(TableCell, null, rate(w.livyOffPer100))))))));
}